export interface XrtSearchResponse<T> {
  duration?: number;
  items: T[];
  pageNumber: number;
  pageSize: number;
  resultCount: number;
}
